import React from "react";


interface Props {
    className?: string;
}

export const Nav: React.FC<Props> = (props) => {
    return <div {...props} />
}